<template>
  <v-container grid-list-sm fluid>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoProceso
            :titulo="iTitulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <SelectCaja
                    :model="itemActivo.Id_Caja"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarCaja"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 md2>
                  <small>Inicial</small><br />
                  <span class="button">
                    {{ itemActivo.SaldoInicial | esMoneda }}
                  </span>
                </v-flex>
                <v-flex xs6 md2>
                  <small>Ingresos</small><br />
                  <span class="button">
                    {{ itemActivo.TotalIngresos | esMoneda }}
                  </span>
                </v-flex>
                <v-flex xs6 md2>
                  <small>Egresos</small><br />
                  <span class="button">
                    {{ itemActivo.TotalEgresos | esMoneda }}
                  </span>
                </v-flex>
                <v-flex xs6 md2>
                  <small>Saldo Final</small><br />
                  <span class="button">
                    {{ itemActivo.Total | esMoneda }}
                  </span>
                </v-flex>
                <v-flex xs6 md2>
                  <Importe
                    refocus="controlFocoTotalRendido"
                    label="Rendido"
                    :model="itemActivo.SaldoFinal"
                    @seleccionarItem="
                      item => (itemActivo.SaldoFinal = item.Importe)
                    "
                  />
                </v-flex>
                <v-flex xs6 md2>
                  <small v-if="iDiferencia > 0">Faltante</small>
                  <small v-else>Sobrante</small>
                  <br />
                  <span class="button">
                    {{ iDiferencia | esMoneda }}
                  </span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-tabs v-model="tabs" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab3">
                      Importes
                      <v-icon>attach_money</v-icon>
                    </v-tab>
                    <v-tab href="#tab4">
                      Comprobantes
                      <v-icon>credit_card</v-icon>
                    </v-tab>
                  </v-tabs>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-tabs-items v-model="tabs">
                    <v-tab-item value="tab3">
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-data-table
                            :headers="grillaHeaders_Ingresos"
                            :items="itemActivo.Ingresos"
                            :items-per-page="10"
                            :hide-default-footer="true"
                            dense
                          >
                            <template v-slot:item="{ item }">
                              <tr @click="mostrarDetalle(item.Codigo)">
                                <td>{{ item.Nombre }}</td>
                                <td class="text-right">
                                  <strong>
                                    {{ item.Importe | esMoneda }}
                                  </strong>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:no-data
                              >-</template
                            >
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-data-table
                            :headers="grillaHeaders_Egresos"
                            :items="itemActivo.Egresos"
                            :items-per-page="10"
                            :hide-default-footer="true"
                            dense
                          >
                            <template v-slot:item="{ item }">
                              <tr @click="mostrarDetalle(item.Codigo)">
                                <td>{{ item.Nombre }}</td>
                                <td class="text-right">
                                  <strong>
                                    {{ item.Importe | esMoneda }}
                                  </strong>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:no-data
                              >-</template
                            >
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-tab-item>
                    <v-tab-item value="tab4">
                      <v-flex>
                        <v-data-table
                          :headers="grillaHeaders_Comprobantes"
                          :items="itemActivo.Comprobantes"
                          :items-per-page="10"
                          :footer-props="{
                            itemsPerPageText: 'Mostrar'
                          }"
                          dense
                        >
                          <template v-slot:item="{ item }">
                            <tr
                              @click="
                                mostrarDetalleComprobante(
                                  item.Codigo,
                                  item.Id_Comprobante
                                )
                              "
                            >
                              <td>
                                <small>{{ item.Fecha | esFechaHora }}</small>
                              </td>
                              <td>
                                <v-chip small>{{
                                  item.NombreTipoComprobante +
                                    " " +
                                    item.LetraTalonario +
                                    " " +
                                    item.Numero
                                }}</v-chip>
                              </td>
                              <td>
                                <v-chip
                                  v-if="esContado(item.NombreCondicionVenta)"
                                  small
                                  outlined
                                  >{{ item.NombreCondicionVenta }}</v-chip
                                >
                                <v-chip
                                  v-else
                                  small
                                  color="success"
                                  text-color="white"
                                  >{{ item.NombreCondicionVenta }}</v-chip
                                >
                              </td>
                              <td>
                                <small>{{ item.NombreTitular }}</small>
                              </td>
                              <td>
                                <small>{{ item.Nota }}</small>
                              </td>
                              <td class="text-right">
                                <strong>{{ item.Total | esMoneda }}</strong>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-data
                            >-</template
                          >
                          <template v-slot:footer>
                            <v-container>
                              <v-layout>
                                <v-flex class="text-right">
                                  Total
                                  <strong>{{
                                    itemActivo.TotalComprobantes | esMoneda
                                  }}</strong>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-tab-item>
                  </v-tabs-items>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
    <ModalDetalleArticulos
      :activo="modalDetalleArticulosActivo"
      :titulo="modalDetalleArticulosTitulo"
      :subtitulo="modalDetalleArticulosSubtitulo"
      :items="itemActivo.Articulos"
      @ejecutarAccion="modalDetalleArticulosEjecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoProceso from "@/components/EncabezadoProceso";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import Importe from "@/components/Importe";
import SelectCaja from "@/components/Caja/SelectCaja";
import ModalDetalleArticulos from "@/components/Stock/ModalDetalleArticulos";
export default {
  name: "CajaPosCierreA",
  components: {
    EncabezadoProceso,
    PieCrud,
    Mensaje,
    Importe,
    SelectCaja,
    ModalDetalleArticulos
  },
  data() {
    return {
      titulo: "Cierre de Turno Administrativo",
      itemVacio: {
        Id_Caja: 0,
        Id_PuntoVenta: 0,
        Fecha: "",
        Turno: 0,
        Id_Empleado: 0,
        NombreEmpleado: "",
        Estado: "",
        Ingresos: [],
        Egresos: [],
        Ventas_VDA: [],
        Ventas_VCC: [],
        Ventas_TAR: [],
        Ventas_CHE: [],
        Ventas_CCC: [],
        Vales: [],
        Comprobantes: [],
        TotalComprobantes: 0,
        Articulos: [],
        Total_VDA: 0,
        Total_VCC: 0,
        Total_TAR: 0,
        Total_CHE: 0,
        Total_CCC: 0,
        SaldoInicial: 0,
        TotalIngresos: 0,
        TotalEgresos: 0,
        Total: 0,
        SaldoFinal: 0
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      grillaHeaders_Ingresos: [
        { text: "Ingresos", value: "Nombre", width: "80%", sortable: false },
        { text: "Importe", sortable: false }
      ],
      grillaHeaders_Egresos: [
        { text: "Egresos", value: "Nombre", width: "80%", sortable: false },
        { text: "Importe", sortable: false }
      ],
      grillaHeaders_Comprobantes: [
        { text: "Fecha", sortable: false },
        {
          text: "Comprobante",
          value: "NombreTipoComprobante",
          sortable: false
        },
        { text: "Condición", value: "NombreCondicionVenta", sortable: false },
        { text: "Titular", value: "NombreTitular", width: "30%" },
        { text: "Nota", sortable: false },
        { text: "Total", sortable: false }
      ],
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: "",
      tabs: "",
      modalDetalleArticulosActivo: false,
      modalDetalleArticulosTitulo: "",
      modalDetalleArticulosSubtitulo: ""
    };
  },
  computed: {
    appId_PuntoVenta() {
      return this.$store.state.appId_PuntoVenta;
    },
    iTitulo() {
      return this.itemActivo.NombrePuntoVenta
        ? this.titulo + " " + this.itemActivo.NombrePuntoVenta
        : this.titulo;
    },
    iDiferencia() {
      return this.itemActivo.Total - this.itemActivo.SaldoFinal;
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Ejecutar":
          if (this.itemActivo.Estado == "C" && this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          else this.$router.go(-1);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
        case "Finalizar":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    modalDetalleArticulosEjecutarAccion(accion) {
      switch (accion) {
        case "Mostrar":
          this.modalDetalleArticulosActivo = true;
          break;
        case "Aceptar":
        case "Cerrar":
          this.modalDetalleArticulosActivo = false;
          break;
      }
    },
    inicializar() {
      this.tabs = "tab3";
      this.itemActivo = Object.assign({}, this.itemVacio);
      setTimeout(() => {
        eventBus.$emit("inicializarSelectCaja");
      }, 100);
    },
    seleccionarCaja(item) {
      if (item.Id_Caja != undefined && item.Id_Caja > 0) {
        this.itemActivo.Id_Caja = item.Id_Caja;
        this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
        this.itemActivo.Fecha = item.Fecha;
        this.itemActivo.Turno = item.Turno;
        this.itemActivo.Id_Empleado = item.Id_Empleado;
        this.itemActivo.NombreEmpleado = item.NombreEmpleado;
        this.itemActivo.SaldoFinal = item.SaldoFinal;
        this.itemActivo.Estado = item.Estado;
        this.buscarDetalle();
      }
      if (this.tabs == "tab4") this.tabs = "tab3";
    },
    buscarDetalle() {
      this.itemActivo.Ingresos = [];
      this.itemActivo.Egresos = [];
      this.itemActivo.Ventas_VDA = [];
      this.itemActivo.Ventas_VCC = [];
      this.itemActivo.Ventas_TAR = [];
      this.itemActivo.Ventas_CHE = [];
      this.itemActivo.Ventas_CCC = [];
      this.itemActivo.Vales = [];
      this.itemActivo.Comprobantes = [];
      this.itemActivo.Articulos = [];
      this.buscarImportes();
    },
    buscarImportes() {
      this.loading = true;
      this.listarTiposImporteCaja();
    },
    listarTiposImporteCaja() {
      HttpHelper.get("TipoImporteCaja/ListarPorPuntoVenta", {
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta
      })
        .then(response => {
          response.data.forEach(item => {
            if (item.CajaColumna == "I") {
              this.itemActivo.Ingresos.push({
                Id_TipoImporteCaja: item.Id_TipoImporteCaja,
                Nombre: item.Nombre,
                Codigo: item.Codigo,
                Importe: 0
              });
            } else {
              this.itemActivo.Egresos.push({
                Id_TipoImporteCaja: item.Id_TipoImporteCaja,
                Nombre: item.Nombre,
                Codigo: item.Codigo,
                Importe: 0
              });
            }
          });
          this.buscarVentas_VDA();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVentas_VDA() {
      this.itemActivo.Total_VDA = 0;
      HttpHelper.get("Venta/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja,
        codigo: this.$codigoTipoImporteCaja_VDA
      })
        .then(response => {
          this.itemActivo.Ventas_VDA = response.data;
          this.itemActivo.Ventas_VDA.forEach(item => {
            this.itemActivo.Total_VDA += item.Total;
          });
          this.buscarVentas_VCC();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVentas_VCC() {
      this.itemActivo.Total_VCC = 0;
      HttpHelper.get("Venta/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja,
        codigo: this.$codigoTipoImporteCaja_VCC
      })
        .then(response => {
          this.itemActivo.Ventas_VCC = response.data;
          this.itemActivo.Ventas_VCC.forEach(item => {
            this.itemActivo.Total_VCC += item.Total;
          });
          this.buscarVentas_TAR();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVentas_TAR() {
      this.itemActivo.Total_TAR = 0;
      HttpHelper.get("Venta/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja,
        codigo: this.$codigoTipoImporteCaja_TAR
      })
        .then(response => {
          this.itemActivo.Ventas_TAR = response.data;
          this.itemActivo.Ventas_TAR.forEach(item => {
            this.itemActivo.Total_TAR += item.Total;
          });
          this.buscarVentas_CHE();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVentas_CHE() {
      this.itemActivo.Total_CHE = 0;
      HttpHelper.get("Venta/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja,
        codigo: this.$codigoTipoImporteCaja_CHE
      })
        .then(response => {
          this.itemActivo.Ventas_CHE = response.data;
          this.itemActivo.Ventas_CHE.forEach(item => {
            this.itemActivo.Total_CHE += item.Total;
          });
          this.buscarVentas_CCC();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVentas_CCC() {
      this.itemActivo.Total_CCC = 0;
      HttpHelper.get("Venta/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja,
        codigo: this.$codigoTipoImporteCaja_CCC
      })
        .then(response => {
          this.itemActivo.Ventas_CCC = response.data;
          this.itemActivo.Ventas_CCC.forEach(item => {
            this.itemActivo.Total_CCC += item.Total;
          });
          this.buscarVales();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVales() {
      HttpHelper.get("Vale/ListarPorCaja", {
        id_Caja: this.itemActivo.Id_Caja
      })
        .then(response => {
          this.itemActivo.Vales = response.data;
          this.calcularTotales();
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    calcularTotales() {
      this.calcularImportes([
        this.$codigoTipoImporteCaja_VDA,
        this.$codigoTipoImporteCaja_VCC,
        this.$codigoTipoImporteCaja_TAR,
        this.$codigoTipoImporteCaja_CHE,
        this.$codigoTipoImporteCaja_CCC,
        this.$codigoTipoImporteCaja_IC,
        this.$codigoTipoImporteCaja_EC
      ]);
      this.limpiarColumnas();
      this.itemActivo.Total =
        this.itemActivo.SaldoInicial +
        this.itemActivo.TotalIngresos -
        this.itemActivo.TotalEgresos;
      setTimeout(() => {
        eventBus.$emit("setearFocoImporte", "controlFocoTotalRendido");
      }, 100);
      this.loading = false;
    },
    calcularImportes(codigos) {
      this.itemActivo.TotalIngresos = this.itemActivo.TotalEgresos = 0;
      this.itemActivo.Ingresos.forEach(item => {
        if (codigos.includes(item.Codigo)) {
          item.Importe = this.calcularImporteCodigo(item.Codigo);
          this.itemActivo.TotalIngresos += Number(item.Importe);
        }
      });
      this.itemActivo.Egresos.forEach(item => {
        if (codigos.includes(item.Codigo)) {
          item.Importe = this.calcularImporteCodigo(item.Codigo);
          this.itemActivo.TotalEgresos += Number(item.Importe);
        }
      });
    },
    calcularImporteCodigo(codigo) {
      let importe = 0;
      switch (codigo) {
        case this.$codigoTipoImporteCaja_VDA:
          importe = this.itemActivo.Total_VDA;
          break;
        case this.$codigoTipoImporteCaja_VCC:
          importe = this.itemActivo.Total_VCC;
          break;
        case this.$codigoTipoImporteCaja_TAR:
          importe = this.itemActivo.Total_TAR;
          break;
        case this.$codigoTipoImporteCaja_CHE:
          importe = this.itemActivo.Total_CHE;
          break;
        case this.$codigoTipoImporteCaja_CCC:
          importe = this.itemActivo.Total_CCC;
          break;
        case this.$codigoTipoImporteCaja_IC:
        case this.$codigoTipoImporteCaja_EC:
          importe = this.calcularVales(codigo);
          break;
      }
      return importe;
    },
    esDebe(valor) {
      return valor == this.$fichaColumna_Debe;
    },
    esContado(valor) {
      return valor == this.$nombreCondicionVenta_Contado;
    },
    calcularVales(codigo) {
      let importe = 0;
      this.itemActivo.Vales.forEach(item => {
        if (
          codigo == this.$codigoTipoImporteCaja_IC &&
          this.esDebe(item.FichaColumna)
        )
          importe += item.Total;
        if (
          codigo == this.$codigoTipoImporteCaja_EC &&
          !this.esDebe(item.FichaColumna)
        )
          importe += item.Total;
      });
      return importe;
    },
    limpiarColumnas() {
      this.itemActivo.Ingresos = this.itemActivo.Ingresos.filter(
        item => item.Importe != 0
      );
      this.itemActivo.Egresos = this.itemActivo.Egresos.filter(
        item => item.Importe != 0
      );
    },
    mostrarDetalle(codigo) {
      this.itemActivo.TotalComprobantes = 0;
      this.itemActivo.Comprobantes = [];
      switch (codigo) {
        case this.$codigoTipoImporteCaja_VDA:
          this.itemActivo.Comprobantes = this.itemActivo.Ventas_VDA;
          this.tabs = "tab4";
          break;
        case this.$codigoTipoImporteCaja_VCC:
          this.itemActivo.Comprobantes = this.itemActivo.Ventas_VCC;
          this.tabs = "tab4";
          break;
        case this.$codigoTipoImporteCaja_TAR:
          this.itemActivo.Comprobantes = this.itemActivo.Ventas_TAR;
          this.tabs = "tab4";
          break;
        case this.$codigoTipoImporteCaja_CHE:
          this.itemActivo.Comprobantes = this.itemActivo.Ventas_CHE;
          this.tabs = "tab4";
          break;
        case this.$codigoTipoImporteCaja_CCC:
          this.itemActivo.Comprobantes = this.itemActivo.Ventas_CCC;
          this.tabs = "tab4";
          break;
        case this.$codigoTipoImporteCaja_IC:
        case this.$codigoTipoImporteCaja_EC:
          this.itemActivo.Vales.forEach(item => {
            if (item.Codigo == codigo) {
              this.itemActivo.Comprobantes.push({
                Codigo: codigo,
                Id_Comprobante: item.Id_Comprobante,
                Fecha: item.Fecha,
                NombreTipoComprobante: item.NombreTipoComprobante,
                LetraTalonario: item.LetraTalonario,
                Numero: item.Numero,
                NombreCondicionVenta: item.NombreCondicionVenta,
                NombreTitular: item.NombreTitular,
                Nota: item.Nota,
                Total: item.Total
              });
            }
          });
          this.tabs = "tab4";
          break;
      }
      this.itemActivo.Comprobantes.forEach(item => {
        this.itemActivo.TotalComprobantes += item.Total;
      });
    },
    mostrarDetalleComprobante(codigo, id_Comprobante) {
      this.armarTitulos(id_Comprobante);
      this.itemActivo.Articulos = [];
      switch (codigo) {
        case this.$codigoTipoImporteCaja_VDA:
        case this.$codigoTipoImporteCaja_VCC:
        case this.$codigoTipoImporteCaja_TAR:
        case this.$codigoTipoImporteCaja_CHE:
        case this.$codigoTipoImporteCaja_CCC:
          HttpHelper.get("Venta/ListarArticulos", {
            id_Venta: id_Comprobante
          })
            .then(response => {
              this.itemActivo.Articulos = response.data;
              this.modalDetalleArticulosActivo = true;
            })
            .catch(error => {
              this.mostrarError(error);
            });
          break;
      }
    },
    armarTitulos(id_Comprobante) {
      var ind = this.itemActivo.Comprobantes.findIndex(
        x => x.Id_Comprobante == id_Comprobante
      );
      this.modalDetalleArticulosTitulo = this.itemActivo.Comprobantes[
        ind
      ].NombreTitular;
      this.modalDetalleArticulosSubtitulo =
        this.itemActivo.Comprobantes[ind].NombreTipoComprobante +
        " " +
        this.itemActivo.Comprobantes[ind].LetraTalonario +
        " " +
        this.itemActivo.Comprobantes[ind].Numero;
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post("Caja/CerrarTurnoAdministracion", item)
        .then(() => {
          this.ejecutarAccion("Finalizar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
